export default {
  en: {
    'pages.invite-expiry.title':
      'Woops... It looks like your invitation to join {product} has expired',
    'pages.invite-expiry.description': 'Please contact {link} to get another invite.',
  },
};
